import {
    GETSUBADMINDETAILSLISTS_SUCCESS,
    GETSUBADMINDETAILSLISTS_FAILED,
    RESET_GETSUBADMINDETAILSLISTS,
    LOADING_GETSUBADMINDETAILSLISTS,
    NETWORK_ERROR_GETSUBADMINDETAILSLISTS,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETSUBADMINDETAILSLISTS:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case GETSUBADMINDETAILSLISTS_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case GETSUBADMINDETAILSLISTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_GETSUBADMINDETAILSLISTS:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_GETSUBADMINDETAILSLISTS:
            return (state = initialState);
        default:
            return state;
    }
};
